/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import PropTypes from 'prop-types';

import cookies from 'browser-cookies';

import { pure } from 'recompose';

import { trackLogout } from 'depop/utils/tracking';

class Logout extends React.Component {
  static contextTypes = {
    resetEnvironment: PropTypes.func,
  };

  handleClick = event => {
    event.preventDefault();

    cookies.erase('token');
    this.context.resetEnvironment(() => {
      trackLogout();
    });
  };

  render() {
    return (
      <a href="javascript:;" onClick={this.handleClick} {...this.props}>
        <FormattedMessage
          id="app.logoutLabel"
          description="Logout Label"
          defaultMessage="Logout"
        />
      </a>
    );
  }
}

export default pure(Logout);



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/Logout.js